import { NgModule } from '@angular/core';
import { LinkChecklistButtonComponent, LinkChecklistDialogComponent } from './components/dialogs/link-checklist/link-checklist-dialog.component';
import { SharedModule } from '../../shared/modules/shared.module';
import { SharedInputModule } from '../../shared/modules/shared-input.module';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../services/dialog.service';
import { ChecklistInputComponent } from './components/input/checklist-input.component';
import { ChecklistsService } from '../../services/checklist.service';
import {
  ChecklistResponseViewAssetDefectsDialogComponent,
  ChecklistResponseComponent,
  ChecklistResponseViewCompletionDetailsDialogComponent,
} from '../../shared/components/widget/checklists/checklist-response/checklist-response.component';
import { ChecklistResponsePromptComponent } from '../../shared/components/widget/checklists/checklist-response/checklist-response-prompt/checklist-response-prompt.component';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { BasicInspectionChecklistDialogComponent, RenderPromptsButtonComponent } from './components/dialogs/render-prompts/render-prompts.component';
import { ChecklistPromptGroupConfigDialogComponent, ConvertChecklistDialogComponent, UpdateChecklistComponent } from '../../admin/checklists/update-checklist/update-checklist.component';
import { ChecklistPromptComponent } from '../../admin/checklists/update-checklist/checklist-prompts/checklist-prompt.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChecklistsGenerateWithArtificationIntelligenceButtonComponent, ChecklistsGenerateWithArtificialIntelligenceDialogComponent } from './components/dialogs/generate-checklist/generate-checklist-dialog.component';
import { ChecklistResponseAssetsListComponent } from './components/lists/asset-lists/assets-lists.component';
import { RouterModule } from '@angular/router';
import { ConvertPdfWithAiModule } from '../../shared/components/convert-pdf-with-ai/convert-pdf-with-ai.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule.forChild(),
    SharedInputModule,
    OwlDateTimeModule,
    DragDropModule,
    RouterModule,
    ConvertPdfWithAiModule
  ],
  declarations: [
    LinkChecklistButtonComponent,
    LinkChecklistDialogComponent,
    ChecklistInputComponent,
    ChecklistResponsePromptComponent,
    ChecklistResponseComponent,
    RenderPromptsButtonComponent,
    BasicInspectionChecklistDialogComponent,
    UpdateChecklistComponent,
    ChecklistPromptComponent,
    ChecklistPromptGroupConfigDialogComponent,
    ChecklistsGenerateWithArtificationIntelligenceButtonComponent,
    ChecklistsGenerateWithArtificialIntelligenceDialogComponent,
    ChecklistResponseAssetsListComponent,
    ChecklistResponseViewCompletionDetailsDialogComponent,
    ChecklistResponseViewAssetDefectsDialogComponent,
    ConvertChecklistDialogComponent,
  ],
  entryComponents: [
    LinkChecklistDialogComponent,
    ChecklistResponseComponent,
    BasicInspectionChecklistDialogComponent,
    ChecklistPromptGroupConfigDialogComponent,
    ChecklistsGenerateWithArtificialIntelligenceDialogComponent,
    ChecklistResponseViewCompletionDetailsDialogComponent,
    ChecklistResponseViewAssetDefectsDialogComponent,
    ConvertChecklistDialogComponent,
  ],
  exports: [
    LinkChecklistButtonComponent,
    ChecklistInputComponent,
    ChecklistResponseComponent,
    RenderPromptsButtonComponent,
    UpdateChecklistComponent,
    ChecklistsGenerateWithArtificationIntelligenceButtonComponent,
  ],
  providers: [
    DialogService,
    ChecklistsService,
  ],
})
export class ChecklistsModule {}